<template>
    <div class="pmtdiv">
        <smallbutton toplabel="Receipt" @click="start()"  :buttonclass="buttonClass" v-if="showButton"/>
      
        <!--  MODAL -->
          <actionmodal ref="mymodal"> 
            <template v-slot:body>
                <form ref="balform" v-if="ticket!=null">
                    
                    <label class="titlelabel">Receipt for Ticket {{ticket.id }}</label>
                    <br/>
                    <br></br>
                    <div class="actiondiv">
                        <label class="receiptlabel">Email Receipt to </label>
                        <input type="text" v-model="emailAddress" class="receiptinput">
                        <smallbutton  @click="sendEmail" toplabel="Send" :disabled="noEmail" buttonclass=" smbutton"/>
                    </div>
                    
                    
                    <div v-if="receiptTextAvailable" class="actiondiv">
                        <label class="receiptlabel">Text Receipt to </label>
                        <input type="text" v-model="phoneNumber" class="receiptinput">
                        <smallbutton  @click="sendText" toplabel="Send" :disabled="noPhone" buttonclass=" smbutton"/>
                    </div>

                    
                    <div class="actiondiv">
                        <label class="receiptlabel">Print to Local Printer</label>
                        <label class=""></label>
                        <button ref="printthereceipt2" class="smbutton" type="button" v-print="'#receiptdatadiv2'" >Print</button>
                    </div>
                    
                    
          
                    <smallbutton  @click="closeme" toplabel="Close" buttonclass="closebutton"/>
                    <div>
                        <label class="responsemessage">{{responseMessage}}</label>
                    </div>

                    <div hidden>
                        <div  class="receiptclass" id="receiptdatadiv2" v-if="receiptData!=null" >
                            <label>{{receiptData}}</label>
                        </div>
                    </div>
                </form>
                
                
            </template>
          </actionmodal>
        </div>
    </template>
    
    <script>
    import {mapFields} from 'vuex-map-fields'
    import format from '../../style/format.js'
    import smallbutton from '../controls/button.vue'
    import linkbutton from '../controls/linkbutton.vue'
    import datamethods from '../../services/datamethods.js'
    import actionmodal from '../controls/actionmodal.vue'
    import pos from '../../services/pos.js'
    import print from 'vue-print-nb'
    export default {
        name:'receiptoptions',
        components:{
            smallbutton,
            linkbutton,
            actionmodal
        },
        directives:{
            print
        },
        props:{
           
            showButton:{
                type:Boolean,
                default:false
            },
       
            buttonClass:{
                type:String,
                default:'button buttonprimary bottom10'
            }
            
        },
        mixins:[format, datamethods,pos],
        data(){
            return{
                name:'Detail',
                trueParam:true, 
                receiptData:null,
                emailAddress:null,
                phoneNumber:null

            }
        },
        computed:{
            ...mapFields([
                'responseMessage',
                'pleaseWait',
         
            ]),
            noEmail(){
                return this.emailAddress==null || this.emailAddress==''
            },
            noPhone(){
                return this.phoneNumber==null || this.phoneNumber==''
            },
            

        },
        methods:{
            closeme(){
                this.$emit('close')
                this.$refs.mymodal.closeModal()
            },
           
            
            start(){
                this.emailAddress=this.guest.EmailAddress
                this.phoneNumber=this.guest.PhoneNumber
                this.getReceiptData()
                this.$refs.mymodal.openModal()
            },
            async sendEmail(){
                console.log('email receipt!')
                let req = {
                    emailAddress:this.emailAddress,
                    subject:'Receipt',
                    body:this.receiptData

                }  
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'sendemail')
                //handle response
            
                if(response.Successful){
                    //this.receiptData=response.StringResponse
                    this.pleaseWait=false;
                    //this.receipt() //print!
                    this.responseMessage = "Email Sent"
                    
                }else{
                    this.responseMessage = response.Message
                }
                this.pleaseWait=false;
            },
            sendText(){
                console.log('text receipt!')
            },
            async getReceiptData(autoreceipt=false){
                let req = {
                    ticket:{
                        id:this.ticket.id
                    }
                }  
              //call api
              this.$store.dispatch('beforeAPI');
              var response = await this.callAPI(req,'ticketreceipt')
              //handle response
          
              if(response.Successful){
                this.receiptData=response.StringResponse
                this.pleaseWait=false;
                //this.receipt() //print!
                
                
              }else{
                this.responseMessage = response.Message
              }
              this.pleaseWait=false;
        },
           
                
        }
    }
    
    </script>
    
    <style>
    .smbutton{
        color:var(--button-text-color);
    border: none;
    border-radius:10px;
    width:60px;
    height:30px;
    padding:0px;
    font-size: medium;
    margin:10px;
  text-decoration: none;
  background-color:var( --button-color);
}
.closebutton{
        color:var(--button-text-color);
    border: none;
    border-radius:10px;
    width:100px;
    height:40px;
    padding:0px;
    font-size: medium;
    margin:10px;
  text-decoration: none;
  background-color:var( --button-color);
}
.actiondiv{
    display:grid;
    grid-template-columns: 2fr 2fr 1fr;
    text-align: left;
    vertical-align:middle;
    height:40px;
    margin:5px;

}
.receiptinput{
    height:30px;
    margin:10px;
}

.receiptlabel{
    margin:10px;
}
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    